var _circle, _circle2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuccessResultBadge = function SvgSuccessResultBadge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 40,
    cy: 40,
    r: 40,
    fill: "#008850"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.08,
    cx: 40,
    cy: 40,
    r: 36,
    fill: "#008850"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.3768 31.8135L50.0797 28.507C50.0248 28.452 49.9597 28.4084 49.8879 28.3786C49.8162 28.3488 49.7393 28.3335 49.6616 28.3335C49.584 28.3335 49.5071 28.3488 49.4353 28.3786C49.3636 28.4084 49.2984 28.452 49.2436 28.507L35.3182 42.4418C35.2634 42.4968 35.1982 42.5404 35.1265 42.5702C35.0547 42.5999 34.9778 42.6153 34.9002 42.6153C34.8225 42.6153 34.7456 42.5999 34.6739 42.5702C34.6021 42.5404 34.537 42.4968 34.4821 42.4418L31.185 39.1352C31.1301 39.0802 31.065 39.0366 30.9933 39.0068C30.9215 38.9771 30.8446 38.9617 30.7669 38.9617C30.6893 38.9617 30.6124 38.9771 30.5406 39.0068C30.4689 39.0366 30.4038 39.0802 30.3489 39.1352L27.0518 42.4418C26.9411 42.5525 26.8789 42.7027 26.8789 42.8592C26.8789 43.0158 26.9411 43.166 27.0518 43.2767L34.4821 50.7082C34.537 50.7632 34.6021 50.8068 34.6739 50.8366C34.7456 50.8664 34.8225 50.8817 34.9002 50.8817C34.9778 50.8817 35.0547 50.8664 35.1265 50.8366C35.1982 50.8068 35.2634 50.7632 35.3182 50.7082L53.3768 32.6402C53.485 32.5298 53.5456 32.3814 53.5456 32.2269C53.5456 32.0723 53.485 31.9239 53.3768 31.8135Z",
    fill: "#008850"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuccessResultBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "success-result-badge.eab952898f51988c4c59209abd1dcbdf.svg";